<template>
    <v-container>
      <v-row>
        <v-col md="12" class="pa-6 text-left text-justify">
          <div class="my-6">
                    <p class="text-h4 text--primary">
                        <TextHeading :level=3>Szkolenia otwarte</TextHeading>
                    </p>
                    <div class="text-body-1 text--primary">
                      Oferujemy Państwu szkolenia z zakresu:
                    </div>
                    <v-list dense disabled>
                      <v-list-item
                        v-for="(item, i) in goals"
                        :key="i"
                      >
                        <v-list-item-icon>
                          <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title class="text-body-1 text--primary text-wrap font-weight-regular">{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                    <div class="text-body-1 text--primary">
                      Szkolenia otwarte organizujemy w Szczecinie, Poznaniu, Gdańsku, Wrocławiu jak i w formie zdalnej.
                    </div>
                    <br />
                    <div class="text-body-1 text--primary">
                      Udział w naszych szkoleniach pozwoli Państwu nawiązać nowe kontakty i wymienić doświadczeniami z innymi uczestnikami. Dodatkowo, po szkoleniu każdy uczestnik ma zagwarantowane 2 godziny konsultacji telefonicznych lub z wykorzystaniem poczty elektronicznej.
                      Informacje na temat programów szkoleniowych, miejsc realizacji szkoleń oraz ceny, znajdziecie Państwo w <router-link class="nav-link" to="/trainings/trainings_schedule">HARMONOGRAMIE SZKOLEŃ</router-link>. 
                    </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import TextHeading from "@/modules/TextHeading";
  export default {
  
    components: {TextHeading},

    data: () => ({
      goals: [
        {
          text: 'Kwalifikowalności wydatków w projektach współfinansowanych ze środków UE;',
          icon: "mdi-circle-medium"
        },
        {
          text: 'Udzielanie zamówień w projektach współfinansowanych ze środków UE, w tym w oparciu o Prawo zamówień publicznych i Zasadę konkurencyjności;',
          icon: "mdi-circle-medium"
        },
        {
          text: 'Budżetowanie projektów współfinansowanych ze środków UE;',
          icon: "mdi-circle-medium"
        },
        {
          text: 'Rozliczanie projektów współfinansowanych ze środków UE - obsługa systemu SL2014;',
          icon: "mdi-circle-medium"
        },
        {
          text: 'Kontroli projektów współfinansowanych ze środków UE;',
          icon: "mdi-circle-medium"
        },
      ],
    })
  }
  </script>